
@switch (this.entity) {
  @case ('Lead') {
    <app-kanban-view-lead [data]="this.data" />
  }
  @case ('Contact') {
    <app-kanban-view-contact [data]="this.data" />
  }
  @case ('Contract') {
    <app-kanban-view-contract [data]="this.data" />
  }
  @case ('Document') {
    <app-kanban-view-documents [data]="this.data" />
  }
  @default {
    <div class="card-list p-3">
      @for (item of data; track item) {
        <div class="card-col">
          <div class="card data-card h-100">
            <div class="card-body">
              <div class="card-content">
                @if (item['name']) {
                  <h5 class="card-title">
                    {{ item["name"] }}
                  </h5>
                }
              </div>
            </div>
            <div class="card-ur-corner-wrapper"></div>
            <a (click)="onCardClick(item['id'])" class="stretched-link"></a>
          </div>
        </div>
      }
    </div>
  }
}
